<div>
  <span class="mat-body-1">Synthèse des demandes</span>
  <mat-chip-listbox>
    <mat-chip [color]="'warn'">{{total_attente}} {{total_attente | i18nPlural: formSvc?.getLabelStatePlural(typeDemandes.En_attente)}}</mat-chip>
    <mat-chip color="primary">{{total_traitement}} {{total_traitement | i18nPlural: formSvc?.getLabelStatePlural(typeDemandes.En_traitement)}}</mat-chip>
    <mat-chip color="accent">{{total_incomplet}} {{total_incomplet | i18nPlural: formSvc?.getLabelStatePlural(typeDemandes.Incomplet)}}</mat-chip>
    <mat-chip>{{total_traitees}} {{total_traitees | i18nPlural: formSvc?.getLabelStatePlural(typeDemandes.Traitees)}}</mat-chip>
    <mat-chip>{{total_archivees}} {{total_archivees | i18nPlural: formSvc?.getLabelStatePlural(typeDemandes.Archivees)}}</mat-chip>
  </mat-chip-listbox>
</div>

